/** @jsx jsx */
import { css } from "@emotion/core"
import { brandColors } from "../../Components/EOSThemeProvider"
import { IItem, itemTypes } from "../../stories/quoteOrders/quoteOrderUtils"

export const bomItemsTableCss = css`
  .table-left-border {
    border-left-width: 5px;
    border-left-color: #4783d6;
    border-left-style: solid;
  }
  .bom-item-table-row {
    /* border-left-style: double !important; */
    background-color: ${brandColors.lightGrey} !important;
    td {
      padding: 0 10px;
      font-size: 11px;
    }
  }
  .left-indented {
    padding-left: 16px;
    border-left-width: 5px;
    border-left-color: #4783d6;
    border-left-style: dotted;
  }
`
export function bomItemTableRowClass(item?: IItem): string | undefined {
  const classList = ["table-left-border"]
  if (item?.type == itemTypes.buildSetItem) {
    classList.push("bom-item-table-row")
  }
  return classList.join(" ")
}
